// api/methodApi.js - Ödeme yöntemleri API istekleri
import axios from 'axios';
import apiClient from './apiClient';

// Göreceli API URL'ini kullan
const API_URL = '/api';

// Axios instance oluştur
const methodApi = axios.create({
  baseURL: `${API_URL}/methods`,
  headers: {
    'Content-Type': 'application/json'
  }
});

// İstek interceptor'ü - her istekte token ekle
methodApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Yanıt interceptor'ü - hata işleme
methodApi.interceptors.response.use(
  (response) => {
    // API yanıtını kontrol et
    console.log('Ödeme yöntemleri API yanıtı:', response.data);
    
    // Eğer response.data bir dizi ise, direkt o diziyi döndür
    if (Array.isArray(response.data)) {
      return response.data;
    }
    
    // Eğer response.data.data bir dizi ise, o diziyi döndür
    if (response.data && Array.isArray(response.data.data)) {
      return response.data.data;
    }
    
    // Eğer response.data bir obje ise ve data alanı yoksa, direkt response.data'yı döndür
    if (response.data && typeof response.data === 'object') {
      return response.data;
    }
    
    // Hiçbir formata uymuyorsa boş dizi döndür
    console.warn('Ödeme yöntemleri beklenmeyen API yanıt formatı:', response.data);
    return [];
  },
  (error) => {
    console.error('Ödeme yöntemleri API hatası:', error.response || error);
    
    const message = 
      error.response?.data?.message || 
      error.message || 
      'Bir hata oluştu';
    
    return Promise.reject(new Error(message));
  }
);

// Tüm ödeme yöntemlerini getir
export const getMethods = async () => {
  try {
    console.log('getMethods: Tüm ödeme yöntemlerini getirme isteği gönderiliyor');
    const response = await methodApi.get('/');
    console.log('getMethods: API yanıtı:', response);
    return response;
  } catch (error) {
    console.error('getMethods: Ödeme yöntemleri alınırken hata:', error);
    throw error;
  }
};

// Belirli bir ödeme yöntemini getir
export const getMethodById = async (id) => {
  return await methodApi.get(`/${id}`);
};

// Yeni ödeme yöntemi oluştur (Admin)
export const createMethod = async (methodData) => {
  return await methodApi.post('/', methodData);
};

// Ödeme yöntemi güncelle (Admin)
export const updateMethod = async (id, methodData) => {
  return await methodApi.put(`/${id}`, methodData);
};

// Ödeme yöntemi sil (Admin)
export const deleteMethod = async (id) => {
  return await methodApi.delete(`/${id}`);
};

export default methodApi; 